export var callingModes = [
    'power',
    'agentless'
];
//# sourceMappingURL=campaignTypes.js.map